"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BlogStore_1 = require("../stores/BlogStore");
const helpers_1 = require("../components/impl/helpers");
const Blog_1 = require("../components/Blog");
const fluxible_router_1 = require("fluxible-router");
class BlogActions {
    static getPosts(context, payload, callback) {
        const postPerPage = (0, helpers_1.getParamValue)(context, 'post per page');
        if (postPerPage) {
            payload.postPerPage = payload.postPerPage || parseInt(postPerPage, 10);
        }
        const blogStore = context.getStore('BlogStore');
        context.service.read('blogPosts', payload, {}, (err, searchResult) => {
            if (err) {
                return;
            }
            let randomResult = [];
            for (const elem of searchResult.results) {
                if (elem.image && elem.image.secure_url) {
                    randomResult.push(elem);
                }
            }
            const length = 3;
            if (randomResult.length > length) {
                randomResult = getRandomArrayElements(randomResult, length);
            }
            context.dispatch(BlogStore_1.POSTS_RECIEVED, new Blog_1.BlogContainer(payload, searchResult, randomResult));
            callback();
        });
    }
    static getCurrentPost(context, payload, callback) {
        context.service.read('post', payload, {}, (err, post) => {
            if (err) {
                callback(err);
                return;
            }
            context.dispatch(BlogStore_1.SINGLE_POST_OPEN, post);
            callback();
        });
    }
    static navigateToCurrentPost(context, payload, callback) {
        BlogActions.getCurrentPost(context, payload, () => {
            (0, fluxible_router_1.navigateAction)(context, {
                method: 'GET',
                url: `/post/${payload.slug}`,
            }, callback);
        });
    }
    static postComment(context, payload, callback) {
        context.service.create('comment', {}, payload, (err, newComment) => {
            if (err) {
                return;
            }
            context.dispatch(BlogStore_1.COMMENT_ADDED, newComment);
            callback();
        });
    }
    static unmountSinglePost(context, payload, callback) {
        context.dispatch(BlogStore_1.UNMOUNT, {});
        callback();
    }
}
exports.default = BlogActions;
function getRandomArrayElements(arr, count) {
    let temp, index, i = arr.length;
    const shuffled = arr.slice(0), min = i - count;
    while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
    }
    return shuffled.slice(min);
}
